import React from 'react';
import { H5, BodySmall, ChipButtonLightGray, ButtonNoStyles } from '@styled';
import colors from '@general/colors';
import PropTypes from 'prop-types';

/**
 * Component: EventTrackSelection
 * Styles are managed in icsc-app/scss/event-sessions-tracks.scss
 */
const EventTrackSelection = ({
    tracks = [],
    selectedTracks = [],
    onToggleTrack,
    onClearAll
}) => {
    return (
        <div className="track-selection-container">
            <div className="track-header-row">
                <div className="track-title-group">
                    <H5>Session Track</H5>
                </div>
                {selectedTracks.length > 0 && (
                    <ButtonNoStyles className="track-clear-all" onClick={onClearAll}>
                        Clear All <span className="close-icon-large">×</span>
                    </ButtonNoStyles>
                )}
            </div>

            <BodySmall style={{ color: colors.black }}>
                Select session tracks to view available sessions within a particular theme for this date.
            </BodySmall>

            <div className="track-wrapper">
                {tracks.map(track => {
                    const isActive = selectedTracks.includes(track.id);
                    return (
                        <ChipButtonLightGray
                            key={track.id}
                            className={isActive ? 'active' : ''}
                            onClick={() => onToggleTrack(track.id)}
                            style={{ margin: 0 }} // Keeping this to override @styled defaults
                        >
                            {track.label} ({track.count})
                            {isActive && (
                                <span className="close-icon-large" style={{ marginLeft: '8px', marginTop: '2px' }}>×</span>
                            )}
                        </ChipButtonLightGray>
                    );
                })}
            </div>
        </div>
    );
};

EventTrackSelection.propTypes = {
    tracks: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            count: PropTypes.number,
        })
    ),
    selectedTracks: PropTypes.arrayOf(PropTypes.string),
    onToggleTrack: PropTypes.func.isRequired,
    onClearAll: PropTypes.func.isRequired,
};

export default EventTrackSelection;
